module.exports = __webpack_public_path__ + "img/Organigrama.cedc2490.jpg";